module.exports = __webpack_public_path__ + "static/media/quality-config-placeholder.4e31c4a8.svg";